import BlacklistPage from './list/BlacklistPage.vue';

const routes = [
  {
    path: '/blacklist',
    name: 'blacklist',
    component: BlacklistPage,
    meta: {
      title: 'Blacklist',
      requiresAuth: true
    }
  }
];

export default routes;
